import { useReactiveVar } from '@apollo/client'
import React from 'react'

import { breakpoints } from '@src/constants/breakpoints'
import { screenResolutionVar } from '@src/models/screenResolution'

import { DesktopNavigation } from './DesktopNavigation'
import { MobileNavigation } from './MobileNavigation'

export const ServiceNavigation: React.FC = () => {
  const { width } = useReactiveVar(screenResolutionVar)

  return (
    <>
      {width >= breakpoints.largeTablet && <DesktopNavigation />}
      {width < breakpoints.largeTablet && <MobileNavigation />}
    </>
  )
}
